<template>
  <b-alert show class="overflow_div ">
    <h6>دسترسی کاربر</h6>

    <div class="selected-category-section">
              <span class="badge badge-primary m-1" style="cursor: pointer"
                    @dblclick="removeItem(index)"
                    v-for="(item,index) in selected_access"
              >{{ item.name }}</span>

      <div class="col-12 mt-3">


        <b-form-input
            id="input"
            v-model="searchedWord"
            placeholder=" جستجو"
            class="mb-1"
        ></b-form-input>
      </div>

    </div>

    <div class="my-2">
      <span @click="addItem(item)" style="cursor: pointer;" class="d-block my-2"
            v-for="(item,index) in user_access">{{ item.name }}</span>
    </div>


  </b-alert>
</template>

<script>
import FormGroup from "@/plugin/components/validator/FormGroup.vue";
import FormErrorsManager from "@/plugin/components/validator/FormErrorsManager.vue";
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";

export default {
  name: "UserAccess",
  components: {FormErrorsManager, FormGroup},
  props: {
    user: {}
  },
  data() {
    return {
      searchedWord: "",
      selected_access: [],
      user_access: [
        {
          name: "همه دسترسی ها",
          route: "*",
          type: "page",
        },
        {

          name: "دسته بندی",


          route: "Category",
          type: "page"


        },
        {

          name: "محصولات",

          route: "ProductsDashboard",
          type: "page"


        },
        {

          name: 'ویژگی های محصول',

          route: 'Feature',
          type: "page"


        },
        {

          name: "برندها",

          route: "Brand",
          type: "page"


        },
        {

          name: "همه سفارش ها",

          route: "Orders",
          type: "page"


        },
        {

          name: "گزارش رزرویشن",

          route: "ReservationOrders",
          type: "page"


        },
        {

          name: "ثبت سفارش",

          route: "CreateOrder",
          type: "page"


        },
        {

          name: "سفارش سریع",

          route: "OrderWithoutItem",
          type: "page"


        },
        {

          name: "همه اقساط",

          route: "LoansAdmin",
          type: "page"


        },
        {

          name: "نرخ پست",

          route: "Deliveries",
          type: "page"


        },
        {

          name: "تخفیفات",

          route: "Offer",
          type: "page"


        },
        {

          name: "آدرس های پیش فرض",

          route: "DefaultAddresses",
          type: "page"


        },
        {

          name: "آمار",

          route: "Statistic",
          type: "page"


        },
        {

          name: "فروشگاه ها",

          route: "MultipleStores",
          type: "page"


        },
        {

          name: "دسته بندی",

          route: "Category",
          type: "page"


        },
        {

          name: "پست ها",

          route: "PostsDashboard",
          type: "page"


        },
        {

          name: "برگه ها",

          route: "PagesDashboard",
          type: "page"


        },
        {

          name: 'مدیریت فایل ها',

          route: 'FileManager',
          type: "page"


        },
        {

          name: "کامنت ها",

          route: "Comments",
          type: "page"


        },
        {

          name: "تگ ها",

          route: "TagsDashboard",
          type: "page"


        },
        {

          name: "محصولات",

          route: "ProductsDashboard",
          type: "page"


        },
        {

          name: "دوره‌ها",

          route: "CoursesDashboard",
          type: "page"


        },
        {

          name: "درس‌ها",

          route: "LessonsDashboard",
          type: "page"


        },
        {

          name: "کاربران دوره",

          route: "AddUserToProduct",
          type: "page"


        },
        {

          name: "فرم ها",

          route: "Form",
          type: "page"


        },
        {

          name: "فرم های پر شده من",

          route: "CurrentUserFormFills",
          type: "page"


        },
        {

          name: "همه چت ها",

          route: "Chats",
          type: "page"


        },
        {

          name: "لیست اشتراک ها",

          route: "AllSubscription",
          type: "page"


        },
        {

          name: "لیست کاربران اشتراک",

          route: "SubscriptionCharges",
          type: "page"


        },
        {

          name: "اتصال به سرویس خارجی",

          route: "LinkToolKid",
          type: "page"


        },
        {

          name: "تنظیمات",

          route: "SiteInfo",
          type: "page"


        },
        {

          name: "مدیریت منوها",

          route: "MenuPanel",
          type: "page"


        },
        {

          name: "تنظیمات ارسال براساس مکان",

          route: "DeliveryPriceBaseOnLocation",
          type: "page"


        },
        {

          name: "زمان بندی ها",

          route: "Timing",
          type: "page"


        },
        {

          name: "زبان",

          route: "Languages",
          type: "page"


        },
        {

          name: "لینک های مفید",

          route: "LinkToolKid",
          type: "page"


        },
        {

          name: "اشتراک گذاری",

          route: "Shares",
          type: "page"


        },
        {

          name: "تنظیمات حسابداری",

          route: "HolooConfig",
          type: "page"


        },
        {

          name: "لاگ",

          route: "Logs",
          type: "page"


        },
        {

          name: "رویدادها",

          route: "Events",
          type: "page"


        },
        {

          name: "پنل پیامک",

          route: 'Sms',
          type: "page"


        },
        {

          name: "کاربران",

          route: "User",
          type: "page"


        },
      ]
    }
  },
  methods: {
    addItem(item) {

      if (this.selected_access.map(item => item.route).indexOf(item.route) > -1) {
        return false;
      }

      this.selected_access.push(item)

      this.$emit("input", this.selected_access)
    },
    removeItem(index) {
      this.selected_access.splice(index, 1);
      toast('ایتم حذف شد', 'ایتم حذف شد', 'success', 'top-left')
      this.$emit("input", this.selected_access)
    }
  },
  watch: {
    user: {
      async handler(newValue, oldValue) {
        if (newValue != null) {
          if (newValue?.meta != null) {
            let access = newValue.meta.find(item => item.name == 'user_access');
            if (access != undefined) {
              this.selected_access = JSON.parse(access.value);
            }
          }
        }
      },
      deep: true
    }
  }

}
</script>

<style scoped>
.overflow_div {
  width: auto;
  height: 300px !important;
  overflow-y: auto;
}

.selected-category-section {
  position: sticky;
  top: 0; /* or bottom: 0; */
  background-color: #f0f0f0;
  padding: 10px;
  border-bottom: 1px solid #ccc;
}
</style>